import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '40px', 
          textAlign: 'center',
          background: 'linear-gradient(135deg, #FFB6C1, #E6E6FA)',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '40px',
            borderRadius: '20px',
            maxWidth: '500px'
          }}>
            <h1 style={{ fontSize: '48px', margin: '0 0 20px 0' }}>🍭</h1>
            <h2 style={{ color: '#d53f8c', marginBottom: '10px' }}>Oops! Something went wrong</h2>
            <p style={{ color: '#718096', marginBottom: '20px' }}>
              {this.state.error?.message || 'An unexpected error occurred'}
            </p>
            <button 
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 24px',
                background: 'linear-gradient(135deg, #FFB6C1, #E6E6FA)',
                border: 'none',
                borderRadius: '50px',
                color: 'white',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
